import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class LoginSubjectTenantLinkQueryCriteriaClass extends BaseCriteriaModel {
  tenant_hdr_guid?: Optional<string> = Optional.empty();
  login_subject_guid?: Optional<string> = Optional.empty();
  mst_role_guid?: Optional<string> = Optional.empty();

}

export class LoginSubjectTenantLinkCriteriaModelQuery {
  query = '';

  constructor(loginSubjectTenantLinkCriteriaModel: LoginSubjectTenantLinkQueryCriteriaClass) {

    if (!loginSubjectTenantLinkCriteriaModel) {
      return;
    }

    this.query += loginSubjectTenantLinkCriteriaModel.tenant_hdr_guid.filter(x => x !== '').map(x => '&tenant_hdr_guid=' + x).orElse('');
    this.query += loginSubjectTenantLinkCriteriaModel.login_subject_guid.filter(x => x !== '').map(x => '&login_subject_guid=' + x).orElse('');
    this.query += loginSubjectTenantLinkCriteriaModel.mst_role_guid.filter(x => x !== '').map(x => '&mst_role_guid=' + x).orElse('');

    this.query += '&status=' + loginSubjectTenantLinkCriteriaModel.status;
    this.query += '&orderBy=' + loginSubjectTenantLinkCriteriaModel.orderBy;
    this.query += '&order=' + loginSubjectTenantLinkCriteriaModel.order;
    this.query += '&offset=' + loginSubjectTenantLinkCriteriaModel.offset + '&limit=' + loginSubjectTenantLinkCriteriaModel.limit;
  }
}
